import React, { useEffect, useState, useCallback } from "react";
import { Table } from "react-bootstrap";
import { getEmpresas, deleteEmpresa, getEmpresaById } from "../helpers/rutaEmpresas";
import ModalEmpresa from "./ModalEmpresa";
import "../css/tableclientes.css";

const COLS = {
  acciones: "40px",
  nro: "20px",
  empresa: "200px",
  cuit: "60px",
  domicilio: "300px", // probá "360px" si querés fijo
};

// Helpers UI
const CellEllipsis = ({ children, title }) => (
  <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={title}>
    {children}
  </div>
);

export default function TableEmpresas() {
  const [state, setState] = useState({
    data: [],
    loading: true,
    error: null,
  });

  const [empresa, setEmpresa] = useState(null);
  const [show, setShow] = useState(false);

  const normalizarLista = (resp) => {
    if (Array.isArray(resp)) return resp;
    if (Array.isArray(resp?.empresas)) return resp.empresas;
    return [];
  };

  const consultaEmpresas = useCallback(async () => {
    try {
      const resp = await getEmpresas();
      const list = normalizarLista(resp);
      setState({ data: list, loading: false, error: null });
    } catch (e) {
      setState((s) => ({
        ...s,
        loading: false,
        error: e?.message || "Error cargando empresas",
      }));
    }
  }, []);

  useEffect(() => {
    consultaEmpresas();
  }, [consultaEmpresas]);

  const handleClose = () => {
    setShow(false);
    consultaEmpresas();
  };

  const handleShow = () => setShow(true);

  const modificaEmpresa = async (id) => {
    try {
      const resp = await getEmpresaById(id);
      const doc = resp?.empresa ?? resp;
      if (!doc) throw new Error("Empresa no encontrada");
      setEmpresa(doc);
      handleShow();
    } catch (e) {
      console.error("❌ Error al obtener empresa:", e);
      alert("No se pudo obtener la empresa.");
    }
  };

  const eliminarEmpresa = async (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar la empresa?");
    if (!confirmar) return;
    try {
      await deleteEmpresa(id);
      await consultaEmpresas();
    } catch (e) {
      console.error("❌ Error al borrar empresa:", e);
      alert("No se pudo borrar la empresa.");
    }
  };

  const { data, loading, error } = state;

  return (
    <div className="table-container">
      {loading && <div className="mt-3">Cargando empresas…</div>}
      {!loading && error && <div className="mt-3 text-danger">Error: {error}</div>}

      {!loading && !error && (
        <>
          <div className="col-12 mt-4" />

          {/* Si querés scroll horizontal, podés envolver esto con <div className="table-responsive"> */}
          <Table
            striped
            bordered
            hover
            className="table-container"
            style={{ tableLayout: "fixed", width: "100%" }}
          >
            <colgroup>
              <col style={{ width: COLS.acciones }} />
              <col style={{ width: COLS.nro }} />
              <col style={{ width: COLS.empresa }} />
              <col style={{ width: COLS.cuit }} />
              <col style={{ width: COLS.domicilio }} />
            </colgroup>

            <thead>
              <tr className="header">
                <th>Acciones</th>
                <th>Nro</th>
                <th className="cli">Empresa</th>
                <th>CUIT</th>
                <th>Domicilio</th>
              </tr>
            </thead>

            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center">
                    Sin empresas
                  </td>
                </tr>
              ) : (
                data
                  .filter((emp) => emp?.activo !== false) // muestra importadas sin activo también
                  .map((emp) => (
                    <tr key={emp._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaEmpresa(emp._id)}
                          title="Editar"
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarEmpresa(emp._id)}
                          title="Eliminar"
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>

                      <td>{emp.codemp ?? "-"}</td>

                      <td className="cli text-start">
                        <CellEllipsis title={emp.empresa ?? emp.razonSocial ?? ""}>
                          {emp.empresa ?? emp.razonSocial ?? "-"}
                        </CellEllipsis>
                      </td>

                      <td>
                        <CellEllipsis title={emp.cuit ?? ""}>{emp.cuit ?? "-"}</CellEllipsis>
                      </td>

                      <td>
                        <CellEllipsis title={emp.domicilio ?? ""}>{emp.domicilio ?? "-"}</CellEllipsis>
                      </td>
                    </tr>
                  ))
              )}
            </tbody>
          </Table>

          <ModalEmpresa show={show} handleClose={handleClose} empresa={empresa || {}} />
        </>
      )}
    </div>
  );
}
